import { render, staticRenderFns } from "./ContratDeService.vue?vue&type=template&id=1815d78d"
import script from "./ContratDeService.vue?vue&type=script&lang=js"
export * from "./ContratDeService.vue?vue&type=script&lang=js"
import style0 from "./ContratDeService.vue?vue&type=style&index=0&id=1815d78d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports